module.exports = __webpack_public_path__ + "static/media/2.be73d54e.svg";